// Libraries
import { Flex } from '@chakra-ui/react';
// Components
import { RatingInfoCompacted } from '@molecules/index';
// Utils
import text from '@translations/en.json';
import { Rating } from '@utils/index';
// Types
import { RatingKeys } from '@globalTypes/index';
import { ChartRatingValuesProps } from './ChartRatingValues.types';

/**
 * The `ChartRatingValues` component displays two compact rating info components side by side.
 * It shows both the current and forecasted ratings. Each rating information has a corresponding description.
 *
 * @param {ChartRatingValuesProps} props - The props to configure the ChartRatingValues component.
 * @param {boolean} props.isLoading - Indicates if the component is in a loading state.
 * @param {Rating} [props.current=Rating.E] - The current rating to display. Default is `Rating.E`.
 * @param {Rating} [props.forecasted=Rating.E] - The forecasted (or simulated) rating to display. Default is `Rating.E`.
 *
 * @returns {ReactElement} The rendered ChartRatingValues component.
 */
export const ChartRatingValues = ({ isLoading, current = Rating.E, forecasted = Rating.E }: ChartRatingValuesProps) => (
  <Flex gap={5}>
    <RatingInfoCompacted
      isLoadingRating={isLoading}
      rating={current as RatingKeys}
      description={text.cii_simulator.chart_simulation_card.current}
      descriptionPosition='row-reverse'
      ratingInfoSize='md'
      descriptionColor='grey.100'
    />
    <RatingInfoCompacted
      isLoadingRating={isLoading}
      rating={forecasted as RatingKeys}
      description={text.forecasted}
      descriptionPosition='row-reverse'
      ratingInfoSize='md'
      descriptionColor='grey.100'
    />
  </Flex>
);
